export default "__VITE_ASSET__Y$1LKG8T__"